export default __webpack_public_path__ + "static/media/mujib100.031897bd.png";